import { useTranslation } from "react-i18next";

export function TableSessionBanner({
  session,
  onRequestBill,
  onViewOrders,
  isRequesting,
  themeColor = "#f97316"
}) {
  const { t } = useTranslation();
  if (!session) return null;

  const { customer_name, order_count = 0, total = 0 } = session;

  const formatPrice = (amount) => {
    return `${amount.toFixed(2).replace(".", ",")}€`;
  };

  const ordersSummary = order_count === 0
    ? t("tableSession.noOrders", "No orders yet")
    : order_count === 1
      ? t("tableSession.ordersCount", "{{count}} order • Total: {{total}}", { count: order_count, total: formatPrice(total) })
      : t("tableSession.ordersCountPlural", "{{count}} orders • Total: {{total}}", { count: order_count, total: formatPrice(total) });

  return (
    <div
      className="mx-3 mt-2 p-3 rounded-xl border"
      style={{
        borderColor: `${themeColor}30`,
        backgroundColor: `${themeColor}08`
      }}
      data-testid="table-session-banner"
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flex-1 min-w-0">
          <p className="text-sm font-bold truncate" style={{ color: themeColor }}>
            {t("tableSession.hello", "Hi, {{name}}!", { name: customer_name })}
          </p>
          <p className="text-xs text-gray-500">
            {ordersSummary}
          </p>
        </div>

        <div className="flex items-center gap-2 flex-shrink-0">
          {order_count > 0 && (
            <button
              onClick={onViewOrders}
              className="px-3 py-1.5 rounded-full text-xs font-medium border transition hover:opacity-80"
              style={{ borderColor: themeColor, color: themeColor }}
              data-testid="view-orders-btn"
            >
              {t("tableSession.viewOrders", "View orders")}
            </button>
          )}

          {order_count > 0 && (
            <button
              onClick={onRequestBill}
              disabled={isRequesting}
              className="px-3 py-1.5 rounded-full text-xs font-bold text-white transition hover:opacity-90 disabled:opacity-50"
              style={{ backgroundColor: themeColor }}
              data-testid="request-bill-btn"
            >
              {isRequesting ? t("tableSession.requesting", "Requesting...") : t("tableSession.requestBill", "Request Bill")}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
